import { render, staticRenderFns } from "./Proprietaire.vue?vue&type=template&id=a882f3c4&scoped=true&"
import script from "./Proprietaire.vue?vue&type=script&lang=js&"
export * from "./Proprietaire.vue?vue&type=script&lang=js&"
import style0 from "./Proprietaire.vue?vue&type=style&index=0&id=a882f3c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a882f3c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/app/site2/src/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a882f3c4')) {
      api.createRecord('a882f3c4', component.options)
    } else {
      api.reload('a882f3c4', component.options)
    }
    module.hot.accept("./Proprietaire.vue?vue&type=template&id=a882f3c4&scoped=true&", function () {
      api.rerender('a882f3c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Proprietaire.vue"
export default component.exports